import { FC, PropsWithChildren } from 'react';

type RevealProps = PropsWithChildren<{
	if: any;
}>;

export const Reveal: FC<RevealProps> = (props) => {
	if (!props.if) {
		return null;
	}

	return <>{props.children}</>;
};
